import { useEffect } from "react";
import { MapContainer, TileLayer, Circle, CircleMarker, useMap, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const BR_CENTER = [-14.235, -51.925];

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => { if (lat != null) map.setView([lat, lng], Math.max(map.getZoom(), 15)); }, [lat, lng, map]);
  return null;
}

function ClickPick({ onPick }) {
  useMapEvents({ click: (e) => onPick(e.latlng.lat, e.latlng.lng) });
  return null;
}

export function GeofenceMap({ lat, lng, radius, onPick }) {
  const has = lat != null && lng != null;
  return (
    <div data-testid="geofence-map" className="h-64 rounded-lg overflow-hidden border relative z-0">
      <MapContainer center={has ? [lat, lng] : BR_CENTER} zoom={has ? 15 : 4} style={{ height: "100%", width: "100%" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        <ClickPick onPick={onPick} />
        <Recenter lat={lat} lng={lng} />
        {has && <Circle center={[lat, lng]} radius={radius} pathOptions={{ color: "#2563eb", fillOpacity: 0.15 }} />}
        {has && <CircleMarker center={[lat, lng]} radius={7} pathOptions={{ color: "#fff", fillColor: "#dc2626", fillOpacity: 1, weight: 3 }} />}
      </MapContainer>
    </div>
  );
}
